import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para todas las etapas de construcción?',
  a: 'Sí. El pack está diseñado para acompañarte desde el Módulo Semilla de 35m² hasta la Vivienda Premium de 95m² — en el orden y el ritmo que tu economía permite.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga. Son archivos PDF de alta resolución, aptos para leer en cualquier dispositivo y para imprimir en A4.'
}, {
  q: '¿Qué lo diferencia de la información gratuita en internet?',
  a: 'La información gratuita en internet no está pensada para Argentina, no tiene el orden correcto, no incluye cómputos de materiales reales ni modelos de contratos ni checklists por etapa. El Pack CI 6×6 es un sistema completo — no información suelta.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días con devolución del 100% sin preguntas ni formularios. Un mensaje es suficiente.'
}, {
  q: '¿Necesito saber de construcción para usarlo?',
  a: 'No. El pack está diseñado específicamente para propietarios sin formación técnica. Cada concepto está explicado en lenguaje claro y sin tecnicismos.'
}, {
  q: '¿Sirve si ya empecé la obra?',
  a: 'Sí. Los Tomos 5 y 6 y las dos Guías Extras aplican directamente a una obra en curso. El Bono 3 puede ayudarte a verificar si la distribución actual funciona antes de levantar más paredes.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-beige" data-id="element-104">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center mb-12" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-107">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-108">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-lg border border-beige-dark overflow-hidden shadow-sm" data-id="element-109">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-110">
                <span className="font-bold text-charcoal pr-8" data-id="element-111">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-112">
                  <ChevronDown className="w-5 h-5 text-gold shrink-0" data-id="element-113" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-114">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-115">
                    <div className="px-6 pb-4 text-gray-600 border-t border-beige-dark pt-4" data-id="element-116">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}